import script from "./NavBtn.vue?vue&type=script&lang=ts&setup=true"
export * from "./NavBtn.vue?vue&type=script&lang=ts&setup=true"

import "./NavBtn.vue?vue&type=style&index=0&id=57280ff1&scoped=true&lang=scss"

import exportComponent from "/github/workspace/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57280ff1"]])

export default __exports__